import { Box } from '@mui/material';
import React from 'react';
import ContactSection from '../ContactSection';
import EBooksSection2 from '../EBooksSection2';
import Footer from '../Footer';
import MarketplaceSection2 from '../MarketplaceSection2';
import OurApproachDark from '../OurApproachDark';
import TheCollective from '../TheCollective';

/**
 * Services section organism component
 * Wraps the MarketplaceSection2 with proper refs and styling
 *
 * @param {Object} props - Component props
 * @param {React.RefObject} props.sectionRef - Ref for scroll targeting
 * @returns {JSX.Element} Services section component
 */
export const ServicesSection = ({ sectionRef }) => (
  <>
    {/* biome-ignore lint/correctness/useUniqueElementIds: Navigation anchor needs static ID for hash routing */}
    <Box ref={sectionRef} id="services" className="scroll-offset">
      <MarketplaceSection2 />
    </Box>
  </>
);

/**
 * Collective section organism component
 * Wraps TheCollective component with proper refs and styling
 *
 * @param {Object} props - Component props
 * @param {React.RefObject} props.sectionRef - Ref for scroll targeting
 * @returns {JSX.Element} Collective section component
 */
export const CollectiveSection = ({ sectionRef }) => (
  <>
    {/* biome-ignore lint/correctness/useUniqueElementIds: Navigation anchor needs static ID for hash routing */}
    <Box ref={sectionRef} id="collective" className="scroll-offset">
      <TheCollective />
    </Box>
  </>
);

/**
 * Contact section organism component
 * Wraps ContactSection with proper refs and styling
 *
 * @param {Object} props - Component props
 * @param {React.RefObject} props.sectionRef - Ref for scroll targeting
 * @returns {JSX.Element} Contact section component
 */
export const ContactSectionWrapper = ({ sectionRef }) => (
  <>
    {/* biome-ignore lint/correctness/useUniqueElementIds: Navigation anchor needs static ID for hash routing */}
    <Box ref={sectionRef} id="contact" className="scroll-offset">
      <ContactSection />
    </Box>
  </>
);

/**
 * EBooks section organism component
 * Standalone section without refs needed
 *
 * @returns {JSX.Element} EBooks section component
 */
export const EBooksSection = () => <EBooksSection2 />;

/**
 * Approach section organism component
 * Standalone section without refs needed
 *
 * @returns {JSX.Element} Approach section component
 */
export const ApproachSection = () => <OurApproachDark />;

/**
 * Footer section organism component
 * Standalone footer without refs needed
 *
 * @returns {JSX.Element} Footer component
 */
export const FooterSection = () => <Footer />;
